
import { Component, Vue, Watch } from "vue-property-decorator";
import History from "./components/History.vue";
import LookRemark from "./components/lookRemark.vue"
import { existedProduct,getEditableInfo,deleteUploadRecord,putEditableInfo,putExtendInfo } from "@/api/order-library";
import { getExtend } from "@/api/product-number";
import {
  IContainerTypesModel,
  IDefaultShippingOrderModel,
  ITypeModel,
  IUserModel,
} from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import { Form, Message } from "element-ui";
import {
  createCustomerWhole,
  getCustomer,
  searchCustomer,
} from "@/api/customer";
import {
  batchDeleteShippingOrders,
  confirmPutShipping,
  createShippingOrderContainerType,
  creatShipping,
  deleteShippingOrderContainerType,
  getShippingOrderStatus,
  searchShippingOrder,
  updateShippingOrderContainerType,
} from "@/api/shipping-order";
// import { cloneDeep } from "lodash";
import { getContainerType } from "@/api/container-type";
import { getUsersByJobPosition } from "@/api/users";
import { Moment } from "moment";
import { ShippingOrderModel } from "@/model/shipping-order";
import { COMPANY_OPTIONS } from "@/constant";
import { map, property } from "lodash";
import Template from "@/views/system-management/template/index.vue";
import {
  searchOrderLibrary,
  searchorderLibraryInfos,
  searchOrderLibraryModels,
  getOrderListRemark,
  downloadOrderLibrary,
} from "@/api/order-library";
import { queryAllNumberTypes } from "@/api/number-type";
import BaseUcenterTable from "@/components/BaseTable/index.vue";
import { provide } from "vue";
import Customer from "@/views/sales-management/customer/index.vue";
import {getCustomerOtherInfo} from "@/api/booking-order";
import { getSuppliersList,getDraftPriceType } from "@/api/inquiry"
import { getList } from "@/api/supplier-payment";
// import { isShallow } from "vue";

@Component({
  name: "orderProductLibrary",
  components: {
    BaseUcenterTable,
    Template,
    Pagination,
    History,
    LookRemark
  },
})
export default class extends Vue {
  // 是否显示所有产品号码
  public remarkInfo = [] as any;
  private showHistory = false;
  public show_remark = false;
  private isShowMore = false;
  public shippingOrder: IDefaultShippingOrderModel[] = [];
  private sellerList: IUserModel[] = [];
  private orderLibraryModelShow = false;
  private actionName = {
    create: "新增",
    createContainerType: "新增柜型",
    editContainerType: "编辑柜型",
    confirmPutShipping: "确认放舱",
  };
  public shippingOrderStatusList: [{ name: string; desc: string }] = [
    { name: null, desc: null },
  ];
  //   vxe表格数据
  private loading = false;
  private columns2 = [];
  private tableData: OrderLibrary[] = [];

  private rule = {
    billLadingCode: [
      { required: true, message: "海运提单号不能为空", trigger: "blur" },
    ],
    company: [{ required: true, message: "请选择公司", trigger: "blur" }],
    shippingMark: [
      { required: true, message: "请输入发货唛头", trigger: "blur" },
    ],
    code: [{ required: true, message: "请输入客户编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入客户全称", trigger: "blur" }],
    address: [{ required: true, message: "请输入客户地址", trigger: "blur" }],
    abbreviation: [
      { required: true, message: "请输入客户简称", trigger: "blur" },
    ],
    tel: [{ required: true, message: "请输入客户电话", trigger: "blur" }],
    country: [{ required: true, message: "请输入国家", trigger: "blur" }],
    departures: [{ required: true, message: "请输入出口港", trigger: "blur" }],
    tradeCountry: [
      { required: true, message: "请输入贸易国", trigger: "blur" },
    ],
    departure: [{ required: true, message: "请输入处境关别", trigger: "blur" }],
    transportation: [
      { required: true, message: "请输入运输方式", trigger: "blur" },
    ],
    destinationCountry: [
      { required: true, message: "请输入最终目的国", trigger: "blur" },
    ],
    deliveryCountry: [
      { required: true, message: "请输入运抵国", trigger: "blur" },
    ],
    internationalTradeTerms: [
      { required: true, message: "请选择国际贸易条款", trigger: "blur" },
    ],
    portDischarge: [
      { required: true, message: "请输入指运港", trigger: "blur" },
    ],
    payment: [{ required: true, message: "请选择付款方式", trigger: "blur" }],
    paymentDetails: [
      { required: true, message: "请输入付款方式详情", trigger: "blur" },
    ],
    ladingType: [
      { required: true, message: "请输入提单类型", trigger: "blur" },
    ],
    sinosure: [
      { required: true, message: "请选择是否单个保中信保", trigger: "blur" },
    ],
    notifier: [{ required: true, message: "请输入通知人", trigger: "blur" }],
    notifierAddress: [
      { required: true, message: "请输入通知人地址", trigger: "blur" },
    ],
    seller: [{ required: true, message: "请选择销售员", trigger: "blur" }],
  };

  private internationalTradeTermsOptions = [
    { label: "FOB", value: "1" },
    { label: "CIF", value: "2" },
    { label: "C&F", value: "3" },
  ];

  private paymentOptions = [
    { label: "定金", value: "1" },
    { label: "赊账付款(OA)", value: "2" },
    { label: "信用证(L/C)", value: "3" },
    { label: "付款交单(DP)", value: "4" },
    { label: "发货前付款", value: "5" },
    { label: "见提单付款", value: "6" },
    { label: "其它", value: "7" },
  ];

  private ladingTypeOptions = [
    { label: "正本", value: "1" },
    { label: "SWB", value: "2" },
    { label: "电放", value: "3" },
    { label: "异地放单", value: "4" },
    { label: "铁路运单COPY", value: "6" },
    { label: "公路运单", value: "7" },
  ];

  private selectSinosureOptions = [
    { label: "是", value: true },
    { label: "否", value: false },
  ];

  private JobPositionType = {
    seller: "seller",
    purchaser: "purchaser",
    logisticsClerk: "logistics-clerk",
  };
  private cascadeProps = {
    multiple: true,
    emitPath: false,
    value: "id",
    label: "name",
  };
  private total = 0;
  private listLoading = true;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();

  //对话框的一个状态
  private dialogStatus = "";
  private dialogFormVisible = false;
  private containerTypeVisible = false;
  private confirmPutShippingVisible = false;

  public payload = {} as WriteShippingOrderInput;
  private LSselectedItem = {} as any;

  private productNumberId: any = "";

  configuredContainerTypes = [{ id: null, name: null, value: null }];
  private listParam = {
    shippingCode: "",
    modelNumber: "",
    customerId: "",
    modelType: "",
    page: 1,
    size: 20,
  };

  created() {
    // 获取所有列配置
    this.$nextTick(() => {
      const table = this.$refs.xTable2 as any;
      let list = table.getColumns();
      let needList = ["客人型号", "H&Q", "OE", "REF"];
      this.columns2 = list.filter((item) => {
        return needList.includes(item.property);
      });
    });
    this.loading = true;
    setTimeout(() => {
      // 将指定列设置为隐藏状态
      this.columns2.forEach((column) => {
        column.visible = false;
      });
      if (this.$refs.xTable2) {
        const table = this.$refs.xTable2 as any;
        table.refreshColumn();
      }
      this.loading = false;
    }, 800);
    this.initContainerTypeList();
    this.initSellerList();
    this.initShippingOrderStatusList();
    this.getNumberTypeList();
    this.getBaseTableCol();
    this.getDraftPriceType();
    this.getSuppliersList();
  }

  activated() {
    this.initContainerTypeList();
    this.initSellerList();
    this.getList();
    this.initShippingOrderStatusList();
    this.getDraftPriceType();
    this.getSuppliersList();
  }

  private async putExtendInfo() {
    let params = {
      productNumberId: this.productNumberId,
    };
    let data = {
      infos: this.remarkInfo,
    };
    await putExtendInfo(params, data);
    this.$notify({
      title: "成功",
      message: "提交成功",
      type: "success",
      duration: 2000,
    });
    this.show_remark = false;
    this.getList();
  }

  private getHiddenColumns() {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes("actionColumns");
    }
  }

  private handleSuccess() {
    this.showHistory = false;
    (this.$refs.table as any).$refs.table.clearSelection();
    this.getList();
  }

  private async handleFilter() {
    this.listParam.page = 1;
    this.getList();
    let params = {
      customerId: this.listParam.customerId,
    };
    const res: any = await existedProduct(params);
    if (!res) {
      this.$notify.error({
        title: "提示",
        message: "存在产品有多个SN，请在下单库下载“异常文件”查看处理",
      });
    }
  }

  private async initShippingOrderStatusList() {
    const { status }: any = await getShippingOrderStatus();
    this.shippingOrderStatusList = status;
  }

  private async getList() {
    const params = { ...this.listParam };
    const { total, list }: any = await searchOrderLibrary(params);
    this.total = Number(total);
    this.tableData = list;
  }

  //新增对话框确认回调
  private onDialogConfirmed() {
    if (this.dialogStatus === "create") {
      this.doCreateData();
    }
  }

  //新增订舱单回调
  private doCreateData() {
    //表单校验
    (this.$refs.dataForm as Form).validate(async (valid) => {
      if (valid) {
        //没有客户的id接下来去创建
        if (!this.payload.customerId) {
          const { id }: any = await createCustomerWhole(this.payload);
          this.payload.customerId = id;
        }
        //有客户的id去更新一下客户表    并且创建订舱单
        await creatShipping(this.payload);
        this.dialogFormVisible = false;
        this.$notify({
          title: "成功",
          message: "创建成功",
          type: "success",
          duration: 2000,
        });
        //查询列表
        await this.getList();
      }
    });
  }

  private async deleteContainerType(containerTypeId: string) {
    await deleteShippingOrderContainerType(containerTypeId);
    this.selectedRow.containerTypeList =
      this.selectedRow.containerTypeList.filter(
        (value) => value.id !== containerTypeId
      );
  }

  //新增订舱单页面
  private showCreateShippingOrderDialog(action: string) {
    //弹框的数据模型
    this.payload = new WriteShippingOrderInput();
    this.dialogStatus = action;
    //显示新增弹框
    this.dialogFormVisible = true;
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate();
    });
  }

  //新增界面检索客户信息
  private async searchCustomer() {
    const customerCode = this.payload.code;
    if (customerCode) {
      const data = (await getCustomer(customerCode)) as WriteShippingOrderInput;
      data.company = this.payload.company;
      data.shippingMark = this.payload.shippingMark;
      this.payload = { ...data };
    }
  }

  //页面加载就加载柜型信息
  private async initContainerTypeList() {
    const data: any = await getContainerType();
    // this.containerTypeOptionsList = data;
  }

  //新增柜型编辑柜型弹框
  private showOperateDialog(action: string, data: ShippingOrderModel) {
    //回显新增柜型操作列表数据
    // this.payload = cloneDeep(data);
    this.selectedRow = data;
    if (action === "createContainerType") {
      //显示新增或编辑柜型对话框
      this.containerTypeVisible = true;
    } else if (action === "editContainerType") {
      //todo 根据订舱单id去查询该订舱单下的柜型
      // const data: any = searchContainerTypesByShippingOrder(data);
      // this.payload.containerTypes = data;
      this.containerTypeVisible = true;
      this.listLoading = false;
    } else if (action === "confirmPutShipping") {
      this.payload = new WriteShippingOrderInput();
      this.confirmPutShippingVisible = true;
    }
    //对话框的一个状态 ,新增/编辑柜型的对话框
    this.dialogStatus = action;
  }

  //页面加载就加载全部用户
  private async initSellerList() {
    const data: any = await getUsersByJobPosition(this.JobPositionType.seller);
    this.sellerList = data;
  }

  private example = false;

  private async getOrderLibraryModels() {
    let ids = this.getListParams();
    if (ids.length <= 0) {
      return;
    }
    this.orderLibraryModelShow = !this.orderLibraryModelShow;
    if (this.orderLibraryModelShow) {
      const data: any = await searchOrderLibraryModels({ ids });
      let orderLibrarySearchModels: OrderLibrarySearchModelRes[] = data;
      let map1 = new Map(
        orderLibrarySearchModels.map((item) => [
          item.orderLibraryId,
          item.modelRes,
        ])
      );
      let numberTypeIdAndCode = new Map(
        this.numberTypeList.map((item) => [item.id, item.code])
      );
      this.tableData.map((value) => {
        let res: ModelRes[] = map1.get(value.orderLibraryId);
        res.forEach((item) => {
          let typeCode = numberTypeIdAndCode.get(item.typeId);
          value[typeCode] = item.number;
        });
      });
      console.log(this.tableData);
      this.getBaseAndModelTableCol();
    } else {
      let index = this.tableCol.findIndex(
        (item) => item.label === "参照号类型"
      );
      this.tableCol.splice(index + 1, this.numberTypeList.length);
    }
  }

  private orderLibraryInfoShow = false;

  private async handlerSeeRemark(row) {
    // 查看备注
    console.log('点击的listROW',row.row)
    this.productNumberId = row.row.productNumberId
    const res = await getExtend(row.row.productNumberId)
    this.remarkInfo = res
    this.show_remark = true
    console.log('res',res)
  }

  private async getOrderLibraryInfos() {
    let ids = this.getListParams();
    if (ids.length <= 0) {
      return;
    }
    this.orderLibraryInfoShow = !this.orderLibraryInfoShow;
    if (this.orderLibraryInfoShow) {
      const data: any = await searchorderLibraryInfos({ ids });
      let infos: OrderLibrarySearchInfoRes[] = data;
      let map1 = new Map(infos.map((item) => [item.id, item]));
      this.tableData.forEach((value) => {
        let res = map1.get(value.orderLibraryId);
        value.productName = res.productName;
        value.technic = res.technic;
        value.technicDesc = res.technicDesc;
        value.productInfo = res.productInfo;
        value.productInfoDesc = res.productInfoDesc;
        value.carApplication = res.carApplication;
        value.description1 = res.description1;
        value.productAttribute1 = res.productAttribute1;
        value.description2 = res.description2;
        value.productAttribute2 = res.productAttribute2;
        value.description3 = res.description3;
        value.productAttribute3 = res.productAttribute3;
        value.description4 = res.description4;
        value.productAttribute4 = res.productAttribute4;
      });
      this.getBaseAndInfoTableCol();
    } else {
      let start = this.tableCol.findIndex((item) => item.label === "华强品名");
      let end = this.tableCol.findIndex((item) => item.label === "供应商名称");
      this.tableCol.splice(start + 1, end - start - 1);
    }
  }

  private removeRemark(index) {
    this.remarkInfo.splice(index, 1);
  }

  private addRemark() {
    this.remarkInfo.push({id: null,type: '',value: ''})
  }

  private getListParams() {
    let ids: any = this.tableData.map((item) => {
      return item.orderLibraryId;
    });
    return ids;
  }

  private numberTypeList: NumberTypeRes[] = [];

  private async getNumberTypeList() {
    queryAllNumberTypes().then((res) => {
      this.numberTypeList = res as any;
    });
  }

  private tableCol = [];

  private getBaseTableCol() {
    this.tableCol = [
      {
        label: "HQ/JR号码",
        prop: "hqOrJrNumber",
        key: "hqOrJrNumber",
      },
      {
        label: "参照号",
        prop: "inquiryReferenceNumber",
        key: "inquiryReferenceNumber",
      },
      {
        label: "参照号类型",
        prop: "inquiryReferenceNumberType",
        key: "inquiryReferenceNumberType",
      },
      {
        label: "华强品名",
        prop: "hqProductName",
        key: "hqProductName",
      },
      {
        label: "供应商名称",
        prop: "supplier",
        key: "supplier",
      },
      {
        label: "下单数量",
        prop: "productQuantity",
        key: "productQuantity",
      },
      {
        label: "采购单价",
        prop: "purchaseUnitPrice",
        key: "purchaseUnitPrice",
      },
      {
        label: "采购折扣",
        prop: "purchaseDiscount",
        key: "purchaseDiscount",
      },
      {
        label: "采购折后单价",
        prop: "purchaseDiscountUnitPrice",
        key: "purchaseDiscountUnitPrice",
      },
      {
        label: "单价类型",
        prop: "unitPriceType",
        key: "unitPriceType",
      },
      {
        label: "采购总价",
        prop: "totalPurchasePrice",
        key: "totalPurchasePrice",
      },
      {
        label: "销售单价",
        prop: "saleUnitPrice",
        key: "saleUnitPrice",
      },
      {
        label: "销售折扣",
        prop: "saleDiscount",
        key: "saleDiscount",
      },
      {
        label: "销售折后单价",
        prop: "saleDiscountUnitPrice",
        key: "saleDiscountUnitPrice",
      },
      {
        label: "销售总价",
        prop: "totalSalePrice",
        key: "totalSalePrice",
      },
      {
        label: "币种",
        prop: "currency",
        key: "currency",
      },
      {
        label: "利润率",
        prop: "profitRate",
        key: "profitRate",
      },
      {
        label: "PI订单号",
        prop: "piNumber",
        key: "piNumber",
      },
      {
        label: "采购订单号",
        prop: "poNumber",
        key: "poNumber",
      },
      {
        label: "PO",
        prop: "customerPoNumber",
        key: "customerPoNumber",
      },
      {
        label: "生产批次号",
        prop: "batchNumber",
        key: "batchNumber",
      },
      {
        label: "备注",
        prop: "remark",
        key: "remark",
      },
      {
        label: "操作",
        prop: "actions",
        key: "actions",
        type: "actions",
        options: [
          { name: "编辑", code: "", click: "handleEdit" },
          {
            name: "查看备注",
            code: "",
            click: "handlerSeeRemark",
          },
          { name: "查看历史报价单", code: "", click: "handleHistory" },
          { name: "删除", code: "", type: "delete", click: "handleDelete" },
        ],
        show: true,
        disabled: false,
        width: 300,
      },
    ];
  }

  private getBaseAndModelTableCol() {
    let index = this.tableCol.findIndex((item) => item.label === "参照号类型");
    this.numberTypeList.map((item) => {
      index = index + 1;
      this.tableCol.splice(index, 0, {
        label: item.name,
        prop: item.code,
        key: item.code,
      });
    });
  }

  private getBaseAndInfoTableCol() {
    let array = [
      {
        label: "productName",
        prop: "productName",
        key: "productName",
      },
      {
        label: "工艺",
        prop: "technicDesc",
        key: "technicDesc",
      },
      {
        label: "technic",
        prop: "technic",
        key: "technic",
      },
      {
        label: "产品信息",
        prop: "productInfoDesc",
        key: "productInfoDesc",
      },
      {
        label: "productInfo",
        prop: "productInfo",
        key: "productInfo",
      },
      {
        label: "车型/Application",
        prop: "carApplication",
        key: "carApplication",
      },
      {
        label: "description1",
        prop: "description1",
        key: "description1",
      },
      {
        label: "产品属性1",
        prop: "productAttribute1",
        key: "productAttribute1",
      },
      {
        label: "description2",
        prop: "description2",
        key: "description2",
      },
      {
        label: "产品属性2",
        prop: "productAttribute2",
        key: "productAttribute2",
      },
      {
        label: "description3",
        prop: "description3",
        key: "description3",
      },
      {
        label: "产品属性3",
        prop: "productAttribute3",
        key: "productAttribute3",
      },
      {
        label: "description4",
        prop: "description4",
        key: "description4",
      },
      {
        label: "产品属性4",
        prop: "productAttribute4",
        key: "productAttribute4",
      },
    ];
    let index = this.tableCol.findIndex((item) => item.label === "华强品名");
    array.forEach((item) => {
      index = index + 1;
      this.tableCol.splice(index, 0, {
        label: item.label,
        prop: item.prop,
        key: item.key,
      });
    });
  }

  private editList = [
    {
      label: "productName",
      prop: "productName",
      key: "productName",
      type: "input",
      placeholder: "请输入华强品名",
      clearable: true,
    },
    {
      label: "description1",
      prop: "description1",
      key: "description1",
      type: "textarea",
      placeholder: "请输入description1",
      clearable: true,
    },
    {
      label: "productAttribute1",
      prop: "productAttribute1",
      key: "productAttribute1",
      type: "textarea",
      placeholder: "请输入productAttribute1",
      clearable: true,
    },
    {
      label: "description2",
      prop: "description2",
      key: "description2",
      type: "textarea",
      placeholder: "请输入description2",
      clearable: true,
    },
    {
      label: "productAttribute2",
      prop: "productAttribute2",
      key: "productAttribute2",
      type: "textarea",
      placeholder: "请输入productAttribute2",
      clearable: true,
    },
    {
      label: "description3",
      prop: "description3",
      key: "description3",
      type: "textarea",
      placeholder: "请输入description3",
      clearable: true,
    },
    {
      label: "productAttribute3",
      prop: "productAttribute3",
      key: "productAttribute3",
      type: "textarea",
      placeholder: "请输入productAttribute3",
      clearable: true,
    },
    {
      label: "description4",
      prop: "description4",
      key: "description4",
      type: "textarea",
      placeholder: "请输入description4",
      clearable: true,
    },
    {
      label: "productAttribute4",
      prop: "productAttribute4",
      key: "productAttribute4",
      type: "textarea",
      placeholder: "请输入productAttribute4",
      clearable: true,
    },
    {
      label: "工艺",
      prop: "technicDesc",
      key: "technicDesc",
      type: "textarea",
      placeholder: "请输入工艺",
      clearable: true,
    },
    {
      label: "technic",
      prop: "technic",
      key: "technic",
      type: "textarea",
      placeholder: "请输入technic",
      clearable: true,
    },
    {
      label: "产品信息",
      prop: "productInfoDesc",
      key: "productInfoDesc",
      type: "textarea",
      placeholder: "请输入productInfoDesc",
      clearable: true,
    },
    {
      label: "productInfo",
      prop: "productInfo",
      key: "productInfo",
      type: "textarea",
      placeholder: "请输入productInfo",
      clearable: true,
    },
    {
      label: "车型/Application",
      prop: "carApplication",
      key: "carApplication",
      type: "textarea",
      placeholder: "请输入carApplication",
      clearable: true,
    },
    {
      label: "供应商",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      value: "",
      placeholder: "请选择供应商",
      remote: true,
      remote_method: this.getSuppliersList,
      clearable: true,
      options: [],
      labelKey: "abbreviation",
      valueKey: "id",
    },
    {
      label: "PI号码",
      prop: "piNumber",
      key: "piNumber",
      type: "input",
      placeholder: "请输入PI号码",
      clearable: true,
    },
    {
      label: "PO号码",
      prop: "poNumber",
      key: "poNumber",
      type: "input",
      placeholder: "请输入PO号码",
      clearable: true,
    },
    {
      label: "下单数量",
      prop: "productQuantity",
      key: "productQuantity",
      type: "inputNumber",
      placeholder: "请输入下单数量",
      clearable: true,
    },
    {
      label: "利润率",
      prop: "profitRate",
      key: "profitRate",
      type: "input",
      placeholder: "请输入利润率",
      clearable: true,
    },
    {
      label: "采购折扣",
      prop: "purchaseDiscount",
      key: "purchaseDiscount",
      type: "input",
      placeholder: "请输入采购折扣",
      clearable: true,
    },
    {
      label: "采购折后单价",
      prop: "purchaseDiscountUnitPrice",
      key: "purchaseDiscountUnitPrice",
      type: "input",
      placeholder: "请输入采购折后单价",
      clearable: true,
    },
    {
      label: "采购单价",
      prop: "purchaseUnitPrice",
      key: "purchaseUnitPrice",
      type: "input",
      placeholder: "请输入采购单价",
      clearable: true,
    },
    {
      label: "销售折扣",
      prop: "saleDiscount",
      key: "saleDiscount",
      type: "input",
      placeholder: "请输入销售折后单价",
      clearable: true,
    },
    {
      label: "销售折后单价",
      prop: "saleDiscountUnitPrice",
      key: "saleDiscountUnitPrice",
      type: "input",
      placeholder: "请输入采购单价",
      clearable: true,
    },
    {
      label: "销售单价",
      prop: "saleUnitPrice",
      key: "saleUnitPrice",
      type: "inputNumber",
      placeholder: "请输入销售单价",
      clearable: true,
    },
    {
      label: "单价类型",
      prop: "unitPriceType",
      key: "unitPriceType",
      type: "select",
      placeholder: "请选择单价类型",
      options: [],
      clearable: true,
      labelKey: "desc",
      valueKey: "name",
    },
    {
      label: "币种",
      prop: "currency",
      key: "currency",
      type: "select",
      placeholder: "请选择币种",
      clearable: true,
      maxlength: 100,
      options: [
        {
          name: "USD",
          id: "USD",
          value: "USD",
        },
        {
          name: "RMB",
          id: "RMB",
          value: "RMB",
        },
        {
          name: "ERUO",
          id: "ERUO",
          value: "ERUO",
        },
      ],
    },
    {
      label: "PO",
      prop: "customerPoNumber",
      key: "customerPoNumber",
      type: "input",
      placeholder: "请输入PO",
      clearable: true,
    },
    {
      label: "生产批次号",
      prop: "batchNumber",
      key: "batchNumber",
      type: "input",
      placeholder: "请输入生辰批次号",
      clearable: true,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "textarea",
      placeholder: "请输入备注",
      clearable: true,
    },
  ];

  private editForm = {} as any;
  private showEdit = false;

  private async getDraftPriceType() {
    const res: any = await getDraftPriceType();
    this.editList[23].options = res;
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.editList[14].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }

  private async handleEdit(row) {
    console.log(row);
    let params = {
      productNumberId: row.row.productNumberId,
    };
    const res: any = await getEditableInfo(params);
    this.editForm = res;
    this.editList[14].options = [
      { id: res.supplierId, abbreviation: res.supplier },
    ];
    this.showEdit = true;
  }

  private async handleDelete(row) {
    console.log(row);
    let params = {
      productNumberId: row.row.productNumberId,
    };
    await deleteUploadRecord(params);
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private customers: [] = [];

  private fetchCustomer(query) {
    if (query !== "") {
      searchCustomer({ keyword: query }).then((res: any) => {
        this.customers = res;
      });
    }
  }

  private async confirmEdit() {
    this.editForm.supplier = this.editForm.supplierId;
    const res: any = putEditableInfo(this.editForm.infoId, this.editForm);
    this.$notify({
      title: "提示",
      message: "编辑保存成功",
      type: "success",
    });
    this.showEdit = false;
    this.getList();
  }

  private async downloadFile() {
    let params = {
      customerId: this.listParam.customerId,
    };
    await downloadOrderLibrary(params);
  }

  public async handleHistory(scope) {
    console.log("点击的那个行", scope.row);
    if (scope.row.productNumberId) {
      this.LSselectedItem = scope.row;
      this.showHistory = true;
      // console.log('this.$refs.historyREF',this.$refs.historyREF);
      (this.$refs.historyREF as any).getListCreate(scope.row);
    } else {
      this.$notify({
        title: "提示",
        message: "该产品没有历史报价单",
        type: "warning",
      });
    }
  }

  private totalContainerQuantity = 0;

  @Watch("configuredContainerTypes", { deep: true, immediate: true })
  private selectedRows: IDefaultShippingOrderModel[] = [];
}

class WriteShippingOrderInput {
  id: string;
  code: string; //客户编号
  name = ""; //客户全称
  abbreviation = ""; //客户简称
  address = ""; //客户地址
  tel = ""; //客户电话
  country = ""; //国家
  departures = ""; //出口港
  tradeCountry = ""; //贸易国
  departure = ""; //出境关别
  transportation = ""; //运输方式
  destinationCountry = ""; //最终目的国
  deliveryCountry = ""; //运抵国
  portDischarge = ""; //指运港
  internationalTradeTerms = ""; //国际贸易条款
  payment = ""; //付款方式
  paymentDetails = ""; //付款方式详情
  ladingType = ""; //提单类型
  sinosure = null; //是否是单个保中信保
  notifier = ""; //通知人
  notifierAddress = ""; //通知人地址
  seller: string; //销售员
  customerId: string; //客户
  startDate: Moment; //开始时间
  billLadingCode = ""; //海运提单号
  typeCount: number; // 共计提柜数量
  combinedContainer: boolean; // 是否拼柜
  containerTypes: IContainerTypesModel[] = [];
  shippingMark = "";
  company: string;
}

interface OrderLibrary {
  orderLibraryId: string;
  hqOrJrNumber: string;
  inquiryReferenceNumber: string;
  inquiryReferenceNumberType: string;
  hqProductName: string;
  supplierName: string;
  saleUnitPrice: number;
  unitPriceType: string;
  currency: string;
  orderUnitPrice: string;
  theAmountOfOrder: string;
  profitRate: string;
  piNumber: string;
  poNumber: string;
  customerPonNumber: string;
  productName: string;
  description1: string;
  productAttribute1: string;
  description2: string;
  productAttribute2: string;
  description3: string;
  productAttribute3: string;
  description4: string;
  productAttribute4: string;
  batchNumber: string;
  technic: string;
  technicDesc: string;
  productInfo: string;
  productInfoDesc: string;
  carApplication: string;
  purchaseDiscount: string;
  purchaseDiscountUnitPrice: string;
  saleDiscount: string;
  saleDiscountUnitPrice: string;
  remark: string;
  [x: string]: any;
}

class OrderLibrarySearchModelRes {
  orderLibraryId: string;
  modelRes: ModelRes[];
}

class ModelRes {
  typeId: string;
  number: string;
}

export class NumberTypeRes {
  id: string;
  name: string;
  code: string;
  description: string;
  weight: string;
}

class OrderLibrarySearchInfoRes {
  id: string;
  productName: string;
  technic: string;
  technicDesc: string;
  productInfo: string;
  productInfoDesc: string;
  carApplication: string;
  description1: string;
  productAttribute1: string;
  description2: string;
  productAttribute2: string;
  description3: string;
  productAttribute3: string;
  description4: string;
  productAttribute4: string;
}
